import axios from "axios";
import actions from "./actions";
import _ from "lodash";
import { generateGuid } from "./../../modules/guid";

const fetchSummaryReportTree = (id) => (dispatch, getState) => {
  dispatch(actions.fetchSummaryReportTreeStart());
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchSummaryReportTreeError(err));
      }
    });
  }
  function getResource(url) {
    return retryOnFail(function() {
      return axios.get(url);
    });
  }
  getResource(`/api/summary-report-tree?id=${id}`).then(res => {
    if (res) {
      dispatch(actions.fetchSummaryReportTree(res.data));
    } else {
      dispatch(actions.fetchSummaryReportTree([]));
    }
  });
};

const fetchSummaryReportTrees = (tree, parent, id) => (dispatch, getState) => {
  dispatch(actions.fetchSummaryReportTreeStart());
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchSummaryReportTreeError(err));
      }
    });
  }
  function getResource(url) {
    return retryOnFail(function() {
      return axios.get(url);
    });
  }
  getResource(`/api/summary-report-trees/${id}?u=${generateGuid()}`).then(res => {
    const summaryReportTree = res.data;
    for (let i = 0; i < summaryReportTree.length; i++) {
      const child = summaryReportTree[i];
      child.name = child.datasetName;
      child.link = child.datasetId ? `/summary-reports/${child.id}` : undefined;
      child.children = child.nodes.length > 0 ? [] : undefined;
      child.loading = child.nodes.length > 0;
    }
  });
};

const clear = () => (dispatch, getState) => {
  dispatch(actions.clear());
};

export default {
  fetchSummaryReportTree,
  fetchSummaryReportTrees,
  clear,
};



// WEBPACK FOOTER //
// ./src/redux/summaryReportTree/operations.js